import React from "react";

import { useOutletContext } from "react-router-dom";

import { default as MSDualWavelength } from '../Models/Calibration/MS_DualWavelength';

const Vitros = () => {
    const { selection } = useOutletContext();
    const { calculation, model } = selection;

    return (
        <div>
            {!model && (
                <p style={{ textAlign: 'center', marginTop: '100px', fontSize: '18px' }}>
                    Select a model from the Calculation Model dropdown
                </p>
            )}

            {calculation === 'Calibration' && model === 'Dual Wavelength (MS)' && <MSDualWavelength />}

        </div>
    );
};

export default Vitros;
